import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M20.555 3.167c-.423-.811-1.166-1.33-2.305-1.655C16.83 1.106 14.797 1 12 1s-4.831.106-6.25.512c-1.14.326-1.883.844-2.306 1.655.762-.295 1.593-.492 2.467-.63C7.59 2.273 9.624 2.2 12 2.2s4.41.073 6.089.337c.874.138 1.705.335 2.466.63"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.808 12.53c-.474.569-1.186.87-2.058.87-.873 0-1.584-.301-2.059-.87-.45-.541-.591-1.209-.591-1.78s.14-1.239.591-1.78c.475-.568 1.186-.87 2.059-.87.872 0 1.584.302 2.058.87.45.541.592 1.209.592 1.78s-.141 1.239-.592 1.78m-1.382-1.153c.096-.116.174-.323.174-.627s-.078-.511-.174-.627c-.073-.087-.236-.223-.676-.223s-.604.136-.676.223c-.097.116-.174.323-.174.627s.077.511.174.627c.072.087.236.223.676.223s.603-.136.676-.223"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.207 13.5C.226 5.188 2.557 4 12 4c9.444 0 11.774 1.188 10.793 9.5C21.812 21.813 20.463 23 12 23s-9.812-1.187-10.793-9.5m2.624-6.471c-.807.657-1.334 2.045-.836 6.26.152 1.294.31 2.365.49 3.258l5.103-3.646 5.116 3.52 3.418-2.356 3.397 2.46c.18-.889.335-1.952.486-3.236.498-4.215-.029-5.603-.836-6.26-.465-.379-1.248-.716-2.64-.936C16.143 5.876 14.345 5.8 12 5.8s-4.144.075-5.528.293c-1.393.22-2.176.557-2.641.936M20.02 18.386l-2.924-2.117-3.39 2.337-5.099-3.507-4.62 3.302c.3.815.636 1.294 1 1.615.428.377 1.072.69 2.215.897 1.163.211 2.698.287 4.798.287s3.635-.076 4.798-.287c1.143-.207 1.787-.52 2.215-.897.367-.323.704-.806 1.006-1.63"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageStackOutlinedSize24Glyph.displayName = 'ImageStackOutlinedSize24Glyph';
